module.exports = __webpack_public_path__ + "img/contact-magnushedvall.809a0d64.png";